// 子仓库 - 配置管理
import to from 'await-to-js';
import { CODES } from "@/api/base/codes";
import * as apis from "@/api/interface/config";
// import * as mock from "@/api/mock/config";


export default {
  namespaced: true,
  state(){
    return {
      zxCityConfigList: undefined, //赠险-城市-列表
      zxInventoryConfigList: undefined, //赠险-库存-列表
      immediateInsureList: undefined, //赠险实时承保 - 列表
      templateSourceList: undefined, //模板资源 - 列表
      filenameList: undefined, //文件名称 - 列表
      linkManagerList: undefined, //链接管理 - 列表
      divideList: undefined, //分流模板 - 列表
      insurefailRecommendList: undefined, //核保失败推荐 - 列表
      sdQwReplyList: undefined, //水滴公众号企微自动回复 - 列表
    }
  },
  getters: {},
  mutations: {
    update(state, payload) {
      Object.keys(payload).forEach((key) => {
        state[key] = payload[key];
      });
    },
  },
  actions: {
    // 母渠道 选项
    async channelOptions(_, payload = {}) {
      const [, res] = await to(apis.channelOptions(payload));
      return res;
    },
    // 子渠道 选项
    async subChannelOptions(_, payload = {}) {
      const [, res] = await to(apis.subChannelOptions(payload));
      return res;
    },
    // 模板配置 -下拉选项集合
    async getTemplateOptions(_, payload = {}) {
      const [, res] = await to(apis.getTemplateOptions(payload));
      return res;
    },
    // 模板配置 - 通过保司获取产品code选项
    async getProductCodeOptionsByInsuranceCompany(_, payload = {}) {
      const [, res] = await to(apis.getProductCodeOptionsByInsuranceCompany(payload));
      return res;
    },




    // 赠险-城市-列表
    async getZxCityConfigList(ctx, payload = {}) {
      const [err, res] = await to(apis.getZxCityConfigList(payload));
      ctx.commit("update", {
        zxCityConfigList: !err && res.code === CODES.SUCCESS ? res.data : undefined,
      });
    },
    // 赠险-城市-新增、修改
    async zxCityConfigAdd(ctx, payload = {}) {
      const [, res] = await to(apis.zxCityConfigAdd(payload));
      return res;
    },
    // 赠险-城市-删除
    async zxCityConfigDelete(ctx, payload = {}){return  await apis.zxCityConfigDelete(payload);},




    // 赠险-库存-列表
    async getZxInventoryConfigList(ctx, payload = {}) {
      const [err, res] = await to(apis.getZxInventoryConfigList(payload));
      ctx.commit("update", {
        zxInventoryConfigList: !err && res.code === CODES.SUCCESS ? res.data : undefined,
      });
    },
    // 赠险-库存-新增、修改
    async zxInventoryConfigAdd(ctx, payload = {}) {
      const [, res] = await to(apis.zxInventoryConfigAdd(payload));
      return res;
    },
    // 赠险-库存-删除
    async zxInventoryConfigDelete(ctx, payload = {}){return  await apis.zxInventoryConfigDelete(payload);},

    // 赠险实时承保 - 列表
    async getImmediateInsureList(ctx, payload = {}) {
      const [err, res] = await to (apis.getImmediateInsureList(payload));
      ctx.commit("update", {
        immediateInsureList: !err && res.data ? res.data : undefined,
      });
    },




    // 模板资源 - 文件名称选项
    async getTemplateSourceFileNameOptions(_, payload = {}) {
      const [, res] = await to(apis.getTemplateSourceFileNameOptions(payload));
      return res;
    },
    // 模板资源 - 文件名称 - 更新
    async sourceFileNameUpdate(ctx, payload = {}) {
      const [, res] = await to(apis.sourceFileNameUpdate(payload));
      return res;
    },
    // 模板资源 - 列表
    async getTemplateSourceList(ctx, payload = {}) {
      const [err, res] = await to (apis.getTemplateSourceList(payload));
      ctx.commit("update", {
        templateSourceList: !err && res.data ? res.data : undefined,
      });
    },
    // 模板资源 - 新增
    async templateSourceAdd(ctx, payload = {}) {
      const [, res] = await to(apis.templateSourceAdd(payload));
      return res;
    },
    // 模板资源 - 文件名称 - 列表
    async getFilenameList(ctx, payload = {}) {
      const [err, res] = await to (apis.getFilenameList(payload));
      ctx.commit("update", {
        filenameList: !err && res.data ? res.data : undefined,
      });
    },
    // 模板资源 - 文件名称 - 批量新增
    async sourceFileNameBatchAdd(ctx, payload = {}) {
      const [, res] = await to(apis.sourceFileNameBatchAdd(payload));
      return res;
    },



    // 链接管理 - 列表
    async getLinkManagerList(ctx, payload = {}) {
      const [err, res] = await to (apis.getLinkManagerList(payload));
      ctx.commit("update", {
        linkManagerList: !err && res.data ? res.data : undefined,
      });
    },



    // 模板资源 - 列表分流模板 - 列表
    async getDivideList(ctx, payload = {}) {
      const [err, res] = await to (apis.getDivideList(payload));
      ctx.commit("update", {
        divideList: !err && res.data ? res.data : undefined,
      });
    },
    // 分流模板 - 通过分流添加获取产品code选项
    async getProductCodeOptionsByDivideAdd(_, payload = {}) {
      const [, res] = await to(apis.getProductCodeOptionsByDivideAdd(payload));
      return res;
    },
    // 分流模板 - 通过分流添加获取模板code选项
    async getTemplateCodeOptionsByDivideAdd(_, payload = {}) {
      const [, res] = await to(apis.getTemplateCodeOptionsByDivideAdd(payload));
      return res;
    },
    // 分流模板 - 新增
    async divideAdd(ctx, payload = {}) {
      const [, res] = await to(apis.divideAdd(payload));
      return res;
    },
      // 分流模板 - 渠道分配
      async divideBindChannel(ctx, payload = {}) {
          const [, res] = await to(apis.divideBindChannel(payload));
          return res;
      },
      // 分流模板 - 查询详情
      async divideDetail(ctx, payload = {}) {
          const [, res] = await to(apis.divideDetail(payload));
          return res;
      },
    // 分流模板 - 生成分流策略
    async divideLinkCreate(ctx, payload = {}) {
      const [, res] = await to(apis.divideLinkCreate(payload));
      return res;
    },
    // 分流模板 - 配置项
    async getDivideConfig(_, payload = {}) {
      const [, res] = await to(apis.getDivideConfig(payload));
      return res;
    },



    // 推荐下拉选项集合
    async getRecomendOptions(ctx, payload = {}) {
      const [, res] = await to(apis.getRecomendOptions(payload));
      return res;
    },
    // 核保失败推荐 - 列表
    async getInsurefailRecommendList(ctx, payload = {}) {
      const [err, res] = await to (apis.getInsurefailRecommendList(payload));
      ctx.commit("update", {
        insurefailRecommendList: !err && res.data ? res.data : undefined,
      });
    },
    // 核保失败推荐 - 新增
    async insurefailRecommendAdd(ctx, payload = {}) {
      const [, res] = await to(apis.insurefailRecommendAdd(payload));
      return res;
    },


    // 水滴公众号企微自动回复 - 下拉选项集合
    async getSdQwOptions(_, payload = {}) {
      const [, res] = await to(apis.getSdQwOptions(payload));
      return res;
    },
    // 水滴公众号企微自动回复 - 列表
    async getSdQwReplyList(ctx, payload = {}) {
      const [err, res] = await to (apis.getSdQwReplyList(payload));
      ctx.commit("update", {
        sdQwReplyList: !err && res.data ? res.data : undefined,
      });
    },
    // 水滴公众号企微自动回复 - 关键词详情
    async getSdQwReplyMsgInfo(ctx, payload = {}) {
      const [, res] = await to (apis.getSdQwReplyMsgInfo(payload));
      return res;
    },
    // 水滴公众号企微自动回复 - 新增、更新
    async sdQwReplyAdd(ctx, payload = {}) {
      const [, res] = await to(apis.sdQwReplyAdd(payload));
      return res;
    },
  },
  modules: {},
};
